module.exports = __webpack_public_path__ + "img/hr-tree-01-i-trunk.4bae54d2.png";